// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__lfaU_","item":"style_item__p9Ik3","active":"style_active__bquuO"};